const ChevronIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 9 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.096 1.363.85 7.95v.001l-.002.001-.012.014a.761.761 0 0 0-.207.534.762.762 0 0 0 .207.534l.013.013v.001l.001.001 6.247 6.589a.722.722 0 0 0 1.056-.015.793.793 0 0 0 .014-1.082L2.438 8.5 8.166 2.46a.793.793 0 0 0-.014-1.083.722.722 0 0 0-1.056-.014Z" fill="currentColor" stroke="currentColor" strokeWidth=".4"/>
    </svg>
  )
}

export default ChevronIcon
